<template>
  <page-container>
    <div class="flex justify-center mb4">
      <a class="flex justify-center items-center tc" href="/">
        <img class="logo mr1" src="@/assets/logo.png" alt="Logo tekk" />
        <h1 class="title tc">
          <span class="has-text-white">tekk</span>
        </h1>
      </a>
    </div>

    <b-message type="is-danger" v-if="error">
      Something went wrong or this link is expired.
    </b-message>

    <loading
      :show="$wait.is('loading.taglink')"
      align="center"
      status="Loading resources"
    ></loading>

    <div v-if="!error && tagLink.tag">
      <h1 class="f2 b mb2">{{ tagLink.title || "Untitled link" }}</h1>
      <div class="flex flex-wrap items-center mb4">
        <!-- <p>Showing resources with tag</p> -->
        <tag-item :style="{ margin: '0' }" :tag="tagLink.tag"></tag-item>
      </div>

      <transition-group tag="div" name="list-up">
        <resource
          v-for="resource in tagLink.tag.resources"
          :key="`resource-${resource.id}`"
          :resource="resource"
          :spacing-horizontal="false"
          context="share"
          :force-show-tags="true"
          :tag-list-props="{
            noContextMenu: true
          }"
        ></resource>
      </transition-group>
    </div>
  </page-container>
</template>

<script>
import Resource from "@/components/resource/ListItem";
import TagItem from "@/shared/components/tag/Item";

export default {
  components: {
    Resource,
    TagItem
  },

  data: () => ({
    tagLink: {},
    error: null
  }),

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      try {
        vm.$wait.start("loading.taglink");
        const res = await vm.axios.get(`tag-links/public/${to.params.uid}`);
        vm.$wait.end("loading.taglink");
        setTimeout(() => {
          vm.$set(vm, "tagLink", res.data.data);
        }, 100);
      } catch (e) {
        vm.error = true;
        vm.$wait.end("loading.taglink");
      }
    });
  }
};
</script>

<style lang="scss">
.logo {
  width: 60px;
  // margin-bottom: 10px;
}

.title {
  font-family: $family-tags;
}
</style>
